import { VersionPageContainer, VersionPageLeftContainer, VersionPageRightContainer } from "./VersionPage.styled";
import VersionList from "../../../../components/VersionList/VersionList";
import PromptConfiguration from "../../../../components/PromptConfiguration";

const VersionPage = () => {
  return <VersionPageContainer>
    <VersionPageLeftContainer>
      <VersionList />
    </VersionPageLeftContainer>
    <VersionPageRightContainer>
        <PromptConfiguration isVersionPage={true} />
    </VersionPageRightContainer>
  </VersionPageContainer>;
};

export default VersionPage;
